/** The tree node currently shown in the properties panel (docs/343 v0 §2/§7). */
export type SelectedNode =
  | { type: "catalog"; key: string }
  | { type: "pack"; key: string }
  | { type: "lesson"; packKey: string; index: number }
  | { type: "packEntry"; catalogKey: string; index: number }
  | { type: "catalogEntry"; catalogKey: string; index: number };

export function selectedNodeKey(node: SelectedNode): string {
  switch (node.type) {
    case "catalog":
    case "pack":
      return `${node.type}:${node.key}`;
    case "lesson":
      return `lesson:${node.packKey}:${node.index}`;
    case "packEntry":
    case "catalogEntry":
      return `${node.type}:${node.catalogKey}:${node.index}`;
  }
}
